import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Minus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Minus } from '@sravni/design-system-icons'
 *
 * <Minus />
 * ```
 */
var Minus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Minus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4 10h12", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Minus };
//# sourceMappingURL=Minus.js.map
